import { useEffect, useState } from "react";
import { WifiOff } from "lucide-react";

export const OfflineBadge = () => {
  const [off, setOff] = useState(!navigator.onLine);
  useEffect(() => {
    const on = () => setOff(false), down = () => setOff(true);
    window.addEventListener("online", on);
    window.addEventListener("offline", down);
    return () => { window.removeEventListener("online", on); window.removeEventListener("offline", down); };
  }, []);
  if (!off) return null;
  return (
    <div className="fixed bottom-12 left-3 z-[60] pointer-events-none rounded-full bg-amber-700 text-white text-xs font-medium px-3 py-1.5 shadow-lg flex items-center gap-1.5 print:hidden" data-testid="offline-badge">
      <WifiOff className="h-3.5 w-3.5" />Offline<span className="hidden sm:inline"> — edits save on this device</span>
    </div>
  );
};
